const Footer = () => {
  return (
    <footer>
      <p>
        This site was made from scratch using my bare hands and half a brain, thanks to React,
        JavaScript, and CSS.
      </p>
    </footer>
  );
};

export default Footer;
